import { Link } from "@heroui/react";
import type { ReactNode } from "react";
import { useResumeBuilder } from "./context";

const Layout = ({ children }: { children: ReactNode }) => {
    const { imprint, privacy, logoUrl } = useResumeBuilder();
    return (
        <div className="flex min-h-full w-full flex-col items-center bg-gray-50">
            <div className="flex min-h-8 w-full items-center justify-center p-4 pb-6">
                {logoUrl && <img src={logoUrl} alt="Logo" className="h-8" />}
            </div>
            {children}
            <div className="flex w-full items-center justify-center gap-4 p-4">
                {imprint && (
                    <Link color="foreground" href={imprint} target="_blank">
                        Impressum
                    </Link>
                )}
                {privacy && (
                    <Link color="foreground" href={privacy} target="_blank">
                        Datenschutz
                    </Link>
                )}
            </div>
        </div>
    );
};

export { Layout };
